import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#b78445",
      dark: "#8d6330",
      light: "#dec095",
    },
    secondary: {
      main: "#0f1b2d",
    },
    background: {
      default: "#f2ede5",
      paper: "#fffdf9",
    },
    text: {
      primary: "#132133",
      secondary: "#596575",
    },
    divider: "rgba(19, 33, 51, 0.1)",
  },
  typography: {
    fontFamily: '"Manrope", "Inter", "Segoe UI", sans-serif',
    h1: {
      fontWeight: 800,
      letterSpacing: "-0.05em",
      fontSize: "clamp(2.65rem, 5.6vw, 5rem)",
      lineHeight: 0.98,
    },
    h2: {
      fontWeight: 800,
      letterSpacing: "-0.045em",
      fontSize: "clamp(2rem, 4vw, 3.4rem)",
      lineHeight: 1.04,
    },
    h3: {
      fontWeight: 800,
      letterSpacing: "-0.04em",
      fontSize: "clamp(1.55rem, 3vw, 2.45rem)",
      lineHeight: 1.1,
    },
    h4: {
      fontWeight: 700,
      fontSize: "clamp(1.35rem, 2vw, 2rem)",
      lineHeight: 1.16,
    },
    h5: {
      fontWeight: 700,
      fontSize: "clamp(1.16rem, 1.5vw, 1.48rem)",
      lineHeight: 1.24,
    },
    h6: {
      fontWeight: 800,
      fontSize: "1rem",
      lineHeight: 1.34,
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.78,
    },
    body2: {
      fontSize: "0.96rem",
      lineHeight: 1.7,
    },
    overline: {
      fontWeight: 800,
      letterSpacing: "0.18em",
      lineHeight: 1.4,
    },
    button: {
      fontWeight: 800,
      textTransform: "none",
      letterSpacing: "0.01em",
    },
  },
  shape: {
    borderRadius: 22,
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        "::selection": {
          backgroundColor: "rgba(183, 132, 69, 0.22)",
        },
      },
    },
    MuiContainer: {
      defaultProps: {
        maxWidth: false,
      },
      styleOverrides: {
        root: {
          width: "100%",
          minWidth: 0,
          maxWidth: "calc(var(--container-max) + (var(--container-gutter) * 2))",
          marginLeft: "auto",
          marginRight: "auto",
          paddingLeft: "var(--container-gutter)",
          paddingRight: "var(--container-gutter)",
        },
      },
    },
    MuiGrid: {
      styleOverrides: {
        root: {
          minWidth: 0,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          minHeight: 48,
          paddingInline: 22,
          borderRadius: 16,
          boxShadow: "none",
          transition: "transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease",
          "&:hover": {
            transform: "translateY(-1px)",
          },
        },
        sizeLarge: {
          minHeight: 54,
          paddingInline: 28,
        },
        contained: {
          background: "linear-gradient(135deg, #b78445 0%, #8d6330 100%)",
          color: "#fff",
          "&:hover": {
            boxShadow: "0 14px 28px rgba(141, 99, 48, 0.22)",
            background: "linear-gradient(135deg, #c08d4f 0%, #8d6330 100%)",
          },
        },
        outlined: {
          borderWidth: 1.5,
          borderColor: "rgba(19, 33, 51, 0.16)",
          "&:hover": {
            borderWidth: 1.5,
          },
        },
        text: {
          "&:hover": {
            backgroundColor: "rgba(183, 132, 69, 0.08)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: "var(--radius-card)",
          backgroundImage: "none",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: "var(--radius-card)",
          boxShadow: "var(--shadow-card)",
          backgroundColor: "var(--color-surface)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 700,
          height: 32,
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        variant: "outlined",
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 18,
          backgroundColor: "rgba(255,255,255,0.86)",
          "&.Mui-focused": {
            boxShadow: "0 0 0 4px rgba(183, 132, 69, 0.12)",
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 18,
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          paddingLeft: "0 !important",
          paddingRight: "0 !important",
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          minWidth: 0,
          overflowWrap: "break-word",
        },
      },
    },
  },
});

export default theme;
